import { hasExternalRewards } from '@/reducers/programsNew'
import { useAppSelector } from '@/hooks'
import { useParams } from 'react-router-dom'

function useExternalPayoutCheck() {
  const { id: utilityProgramIdParam } = useParams<{ id: string }>()
  const utilityProgramId = parseInt(utilityProgramIdParam)
  const isExternalReward = useAppSelector(hasExternalRewards(utilityProgramId))
  return isExternalReward
}

const RewardHelpers = {
  useExternalPayoutCheck,
}

export default RewardHelpers
